module.exports = __webpack_public_path__ + "static/eat-5fb97b6faa846b16f6862e84046365b8.png";